(function () {

  const injectStyleOnce = (shadowRoot, id, css) => {
    if (!shadowRoot.querySelector(`#${id}`)) {
      const style = document.createElement("style");
      style.id = id;
      style.textContent = css;
      shadowRoot.appendChild(style);
    }
  };

  const waitForElementInShadow = (shadowRoot, selector, callback) => {
    const el = shadowRoot.querySelector(selector);
    if (el) {
      callback();
      return;
    }

    const observer = new MutationObserver(() => {
      const target = shadowRoot.querySelector(selector);
      if (target) {
        observer.disconnect();
        callback();
      }
    });

    observer.observe(shadowRoot, { childList: true, subtree: true });
  };

  const waitForCustomElementShadow = (shadowRoot, tag, callback) => {
    const el = shadowRoot.querySelector(tag);
    if (el && el.shadowRoot) {
      callback(el.shadowRoot);
      return;
    }

    const observer = new MutationObserver(() => {
      const target = shadowRoot.querySelector(tag);
      if (target && target.shadowRoot) {
        observer.disconnect();
        callback(target.shadowRoot);
      }
    });

    observer.observe(shadowRoot, { childList: true, subtree: true });
  };

  const tryInit = () => {
    const widgetRoot = document.querySelector("recharge-subscription-widget");
    if (!widgetRoot) {
      return false;
    }

    const shadow = widgetRoot.shadowRoot;
    if (!shadow) {
      return false;
    }

    // Esperar elementos base para inyectar estilos
    waitForElementInShadow(shadow, ".rc-purchase-option__selector", () => {
      injectStyleOnce(shadow, "custom-recharge-style", `
        .rc-purchase-option__selector {
          font-size: 14px !important;
        }
        .rc-purchase-option__sub-container {
          flex-direction: column-reverse !important;
        }
      `);
    });

    // rc-benefits
    waitForCustomElementShadow(shadow, "rc-benefits", (innerShadow) => {
      injectStyleOnce(innerShadow, "custom-benefits-style", `
        ul > li {
          padding-left: 15px;
        }
        ul > li::before {
          content: '';
          height: 5px;
          width: 5px;
          position: absolute;
          top: 40%;
          left: 0;
          mask-image: none;
          background-color: var(--rc-widget-bullet-icon-image-color, var(--rc-widget-brand-color));
          border-radius: 100% !important;
        }
      `);
    });

    // rc-selling-plans
    waitForCustomElementShadow(shadow, "rc-selling-plans", (innerShadow) => {
      injectStyleOnce(innerShadow, "custom-plans-style", `
        select.rc-plans-dropdown__select {
          border-radius: 1000px;
          background: #ECECEC;
          border: none;
          height: 35px;
          font-family: 'DM Sans';
        }
      `);
    });

    return true;
  };

  const interval = setInterval(() => {
    if (tryInit()) {
      clearInterval(interval);
    }
  }, 300);

  const observer = new MutationObserver(() => {
    if (tryInit()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
